import {
	useMutation,
	type ApolloCache,
	type DefaultContext,
	type MutationHookOptions,
	type NoInfer,
	type OperationVariables,
	type TypedDocumentNode,
} from "@apollo/client";

import type { Payload } from "../gql/__generated__/graphql";
import type { FetchResult, MutationFunctionOptions, MutationResult, ApolloError } from "@apollo/client";

type MutationResultDataType = {
	[key: string]: Payload;
};

export type MutationSideEffectHandler = (props: { error: ApolloError | undefined }) => void;

export const customMutation =
	(sideEffectHandler: MutationSideEffectHandler) =>
	<
		TData = MutationResultDataType,
		TVariables = OperationVariables,
		TContext = DefaultContext,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		TCache extends ApolloCache<any> = ApolloCache<any>,
	>(
		mutation: TypedDocumentNode<TData, TVariables>,
		options?: MutationHookOptions<NoInfer<TData>, NoInfer<TVariables>, TContext, TCache>,
	): {
		mutationFunc: (
			options?: MutationFunctionOptions<TData, TVariables, TContext, TCache>,
		) => Promise<FetchResult<TData>>;
		mutationResult: Pick<MutationResult<TData>, "data" | "loading">;
	} => {
		const [mutationFunc, { data, error, loading }] = useMutation(mutation, { ...options, errorPolicy: "all" });

		sideEffectHandler({
			error,
		});

		return {
			mutationFunc,
			mutationResult: {
				data,
				loading,
			},
		};
	};
